
import { TagCategory } from 'apprise-core/category';
import { Tag } from 'apprise-core/tag';
import { useCategoryClone } from 'apprise-frontend-tags/category/context';
import { useRouting } from 'apprise-ui/utils/routing';
import { allCategoriesTab } from '../list';
import { useCategoryModel } from './model';




export const tagSystemRoute = "/tags"
export const categoryRoute = `${tagSystemRoute}/category`

export const downloadParam = 'donwload'

export const useCategoryRouting = () => {

    const { routeTo, query } = useRouting()

    const categorystate = useCategoryClone()

    const categories = useCategoryModel()

    const self = {

        categoryListRoute: () => `${tagSystemRoute}?tab=${allCategoriesTab}`

        ,

        categoryDetailRoute: (id?: string) => id ? `${categoryRoute}/${id}` : self.newCategoryRoute()

        ,

        innerDetailRoute: (id?: string) => `${self.categoryDetailRoute(id)}${query()}`
    

        ,

        tagsInCategoryRoute: (id: string) => `${self.categoryDetailRoute(id)}/?tab=${allCategoriesTab}`


        ,

        tagInCategoryRoute: (cat: string, id: string) => `${self.categoryDetailRoute(cat)}/tag/${id}`

        ,

        newCategoryRoute: () => `${categoryRoute}/new`

        ,

        routeToCategory: (category: string | TagCategory) => routeTo(`${self.categoryDetailRoute(typeof category === 'string' ? category : category.id)}?${query()}`)

        ,

        routeToInnerCategory: (category: string | TagCategory) => `${self.routeToCategory(category)}?${query()}`


        ,

        routeToNewDetail: (model? : TagCategory) => {

            model ?   categorystate.set( s => s.clone = model):  categorystate.resetQuietly()
            
            routeTo(self.newCategoryRoute()) 
        
        }

        ,

        routeToTagCategory: (category: string | TagCategory, tag: string| Tag) => routeTo(self.tagInCategoryRoute(typeof category === 'string' ? category : category.id, typeof tag === 'string' ? tag : tag.id))

        ,

        routeToCategoryList: () => routeTo(self.categoryListRoute())

        ,

        nextCategory: () => categorystate.get().clone ?? categories.newCategory(undefined!)


    }

    return self

}

